// import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {},
    info: {
      [theme.fn.largerThan('sm')]: {
        alignItems: 'flex-start',
      },
    },
    selector: {
      [theme.fn.smallerThan('sm')]: {
        alignItems: 'center',
      },
    },
    desc: {
      [theme.fn.smallerThan('sm')]: {
        textAlign: 'center',
      },
    },
    colLeft: {
      [theme.fn.largerThan('sm')]: {
        display: 'flex',
        alignItems: 'center',
      },
    },
    colRight: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      // background: `url(${CommonGAssets.getAssetPath(
      //   'airPopulation/not-found-bg.png',
      // )})`,
      // backgroundSize: 'contain',
      // backgroundRepeat: 'no-repeat',
    },
  }
})
